import { useTranslation } from '@mint-lib/i18n';
import { Divider, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { PrivateFolderCard } from './PrivateFolderCard.jsx';

type Props = {
  canSeeOthersPrivateFolders: boolean;
  myPrivateFolderId: string | null;
  canCreateOwnPrivateFolder: boolean;
  isCreatingOwnPrivateFolder: boolean;
  onOpenOwnPrivateFolder: (folderId: string) => void;
  onCreateOwnPrivateFolder: () => void;
  onOpenUsersPrivateFolders: () => void;
};

const PrivateFoldersSection = ({
  canSeeOthersPrivateFolders,
  myPrivateFolderId,
  canCreateOwnPrivateFolder,
  isCreatingOwnPrivateFolder,
  onOpenOwnPrivateFolder,
  onCreateOwnPrivateFolder,
  onOpenUsersPrivateFolders,
}: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  if (
    !canSeeOthersPrivateFolders &&
    !myPrivateFolderId &&
    !canCreateOwnPrivateFolder
  ) {
    return null;
  }

  return (
    <section className="flex flex-col gap-4" data-testid="private-folders">
      <div
        className={cn(
          'uppercase',
          typographyVariants({ variant: 'h5', color: 'primary' }),
        )}
      >
        {t('Private folders')}
      </div>

      <div className="flex flex-row flex-wrap gap-4">
        {canSeeOthersPrivateFolders && (
          <PrivateFolderCard
            name={t('Users private folders')}
            onOpen={onOpenUsersPrivateFolders}
            ddActionName="Knowledge base: open users private folders"
          />
        )}

        {myPrivateFolderId && (
          <PrivateFolderCard
            name={t('My private folder')}
            onOpen={() => onOpenOwnPrivateFolder(myPrivateFolderId)}
            ddActionName="Knowledge base: open my private folder"
          />
        )}

        {!myPrivateFolderId && canCreateOwnPrivateFolder && (
          <PrivateFolderCard
            name={t('My private folder')}
            actionLabel={t('Create')}
            disabled={isCreatingOwnPrivateFolder}
            onOpen={onCreateOwnPrivateFolder}
            ddActionName="Knowledge base: create my private folder"
          />
        )}
      </div>

      <Divider />
    </section>
  );
};

export { PrivateFoldersSection };
